import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const staffingFaqs = [
  {
    question: 'How do I choose the right staffing model?',
    answer: 'Start with the duration of the work, the skills you need and whether the role could become permanent. We can discuss those requirements with you and recommend a contract, temporary, permanent or contract-to-hire approach.',
  },
  {
    question: 'What is the difference between contract and temporary staffing?',
    answer: 'Contract staffing is generally tied to a defined project or agreed period. Temporary staffing helps cover a shorter-term workload increase, absence or urgent gap. The best fit depends on your expected timeline and responsibilities.',
  },
  {
    question: 'Can a contract professional become a permanent employee?',
    answer: 'Yes. Contract-to-hire gives your team time to work with a professional before deciding on a permanent role, subject to the terms agreed at the start of the engagement.',
  },
  {
    question: 'Can you help us find specialized technology talent?',
    answer: 'We can help you define the skills and experience needed for roles across software development, cloud, data, AI and quality engineering. The hiring approach can be shaped around a single specialist or a wider team.',
  },
  {
    question: 'How is staff augmentation different from managed services?',
    answer: 'With staff augmentation, additional professionals work alongside your team under your day-to-day direction. In a managed services arrangement, an agreed scope of work and delivery responsibilities are handled as a service.',
  },
  {
    question: 'What information should we share to get started?',
    answer: 'Share the role or project scope, required skills, expected duration, preferred working arrangement and target start date. Those details help us discuss a suitable model and the next steps.',
  },
];

export default function StaffingFaqs() {
  const [openFaq, setOpenFaq] = useState(null);
  return (<section className="bg-white px-5 py-16 sm:px-6 lg:px-10 lg:py-12" aria-labelledby="staffing-faq-title">
      <div className="mx-auto max-w-6xl">
        <h2 id="staffing-faq-title" className="text-center text-[32px] font-semibold leading-[48px]" style={{ color: '#183762', marginBottom: 0 }}>Frequently Asked Questions</h2>
        <p className="mx-auto mt-5 max-w-3xl text-center text-base font-normal leading-[27px]" style={{ color: '#212121' }}>Practical answers about choosing a staffing model and building the right team.</p>
        <div className="mt-10 border-t" style={{ borderColor: '#D8E5EF' }}>
          {staffingFaqs.map((faq, index) => {
            const isOpen = openFaq === index;
            return <div key={faq.question} className="border-b" style={{ borderColor: '#D8E5EF' }}>
              <h3>
                <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`staffing-faq-answer-${index}`} className="flex w-full items-center justify-between gap-5 py-5 text-left text-base font-semibold sm:py-6 sm:text-lg" style={{ color: '#183762' }}>
                  {faq.question}
                  <ChevronDown size={21} className={`shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" />
                </button>
              </h3>
              <div id={`staffing-faq-answer-${index}`} hidden={!isOpen}>
                <p className="max-w-4xl pb-6 text-base font-normal leading-[27px]" style={{ color: '#212121', textAlign: 'left', hyphens: 'none' }}>{faq.answer}</p>
              </div>
            </div>;
          })}
        </div>
      </div>
    </section>);
}
